import { DialogContent, DialogHeader, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledCardContent = styled(DialogContent) `
  padding: ${themeGet('spacing.lg')};
`;
export const LoaderContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${pxToRem(100)};
`;
export const StyledDialogHeader = styled(DialogHeader) `
  border-bottom: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  padding: ${themeGet('spacing.xl')} 0;
`;
